import {
  createSlice,
  createAsyncThunk,
  PayloadAction,
  isRejected
} from '@reduxjs/toolkit'
import {
  getEmailEnabled,
  getRegistrationEnabled,
  postPasswordReset
} from '../../services/endpoints/accounts'
import { NetworkRequestError } from '../../services/lib'

const sliceName = 'accounts'

export type AccountsState = {
  emailEnabled?: boolean
  passwordReset?: string | null
  registrationEnabled?: boolean
  loading?: boolean
  error?: string | NetworkRequestError | null
}

export const isEmailEnabled = createAsyncThunk(
  `${sliceName}/emailEnabled`,
  async (_, { rejectWithValue }) => {
    try {
      return await getEmailEnabled()
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const resetPassword = createAsyncThunk(
  `${sliceName}/passwordReset`,
  async (username: string, { rejectWithValue }) => {
    try {
      return await postPasswordReset(username)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const isRegistrationEnabled = createAsyncThunk(
  `${sliceName}/registrationEnabled`,
  async (_, { rejectWithValue }) => {
    try {
      return await getRegistrationEnabled()
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const initialAccountsState: AccountsState = {
  emailEnabled: true,
  passwordReset: ''
}

export const accountsSlice = createSlice({
  name: sliceName,
  initialState: initialAccountsState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(isEmailEnabled.fulfilled, (state, action) => {
        state.emailEnabled = action.payload
        state.loading = false
        state.error = null
      })
      .addCase(isEmailEnabled.pending, (state, _action) => {
        state.loading = true
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.passwordReset = action.payload
        state.loading = false
        state.error = null
      })
      .addCase(resetPassword.pending, (state, _action) => {
        state.loading = true
      })
      .addCase(isRegistrationEnabled.fulfilled, (state, action) => {
        state.registrationEnabled = action.payload
        state.loading = false
        state.error = null
      })
      .addCase(isRegistrationEnabled.pending, (state, _action) => {
        state.loading = true
      })
      .addMatcher(
        isRejected,
        (state, action: PayloadAction<NetworkRequestError>) => {
          if (sliceName === action.type.split('/')[0]) {
            state.loading = false
            state.error = action.payload
          }
        }
      )
  }
})
